<article class="ul-card">
  <comp-card-header>
    <span headline>{{ 'model.product.plural' | translate }}</span>
    <span subtitle>{{ 'products.pageSubtitle' | translate }}</span>
    <ng-container action-items>
      <div class="prime-action-bar">
        <button comp-button type="button" (click)="addProduct()" [disabled]="addDisabled()">
          <i comp-icon aria-hidden="true">add</i>
          <span>{{ 'products.add' | translate }}</span>
        </button>
      </div>
    </ng-container>
  </comp-card-header>

  <comp-paged-table
    [dataSource]="dataSource"
    [editingSupport]="editingSupport"
    [filteringSupport]="filteringSupport()"
    [columns]="[
      'name',
      'latestRevisionName',
      'description',
      'latestRevisionIntakeType',
      'progress',
      'openFindingsCount',
      'latestRevisionDeclarationStatus',
      'lastUpdated',
    ]"
    [modelObjectProperty]="'model.product'"
    [enableFilter]="true"
  >
    <ng-container matColumnDef="name">
      <!--
        The default sort order for products is "by name, ascending".
        See com.ul.sis.companion.webapp.api.convert.ComparatorConfiguration
        However, you have to set start="desc" here, because the "start" attribute sets the sort order
        that is applied *after* the first click.
         -->

      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'products.columns.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        <a [routerLink]="[product.id]" class="product-name" (click)="$event.stopPropagation()">
          <div class="click-area">
            {{ product.name }}
          </div>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear start="desc">
        {{ 'products.columns.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        <comp-description [description]="product.description" [showMaxLines]="1"></comp-description>
      </td>
    </ng-container>

    <ng-container matColumnDef="latestRevisionName">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'products.columns.latestRevisionName' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        @if (product.latestRevisionId) {
          <a
            [routerLink]="[product.id, product.latestRevisionId]"
            (click)="$event.stopPropagation()"
          >
            <div class="click-area">
              {{ product.latestRevisionName }}
            </div>
          </a>
        } @else {
          {{ product.latestRevisionName }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="latestRevisionIntakeType">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'products.columns.latestRevisionIntakeType' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        @if (product.latestRevisionIntakeType) {
          <comp-intake-type-chip
            [intakeType]="product.latestRevisionIntakeType"
          ></comp-intake-type-chip>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="progress">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'products.columns.progress' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        <comp-progress-bar
          [done]="product.completedRequirementsCount"
          [total]="product.totalRequirementsCount"
        ></comp-progress-bar>
      </td>
    </ng-container>

    <ng-container matColumnDef="openFindingsCount">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'products.columns.openFindingsCount' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        <ul-chip
          [additionalClasses]="{
            green: product.openFindingsCount === 0,
            yellow: product.openFindingsCount > 0,
            red: product.openFindingsCount >= 10,
          }"
          [showDot]="true"
        >
          @if (product.openFindingsCount == 0) {
            {{ 'general.none' | translate }}
          } @else {
            {{ 'products.openFindingsCount' | translate: { count: product.openFindingsCount } }}
          }
        </ul-chip>
      </td>
    </ng-container>

    <ng-container matColumnDef="latestRevisionDeclarationStatus">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'products.columns.latestRevisionDeclarationStatus' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        @if (product.latestRevisionDeclarationStatus) {
          <ul-chip
            [additionalClasses]="{
              neutral: product.latestRevisionDeclarationStatus === 'PENDING',
              green: product.latestRevisionDeclarationStatus === 'VALID',
              red: product.latestRevisionDeclarationStatus === 'REVOKED',
            }"
          >
            {{
              'model.productRevision.declarationStatus.' + product.latestRevisionDeclarationStatus
                | translate
            }}
          </ul-chip>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="lastUpdated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
        {{ 'products.columns.lastUpdated' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        {{ product.lastUpdated | date: 'shortDate' }}
      </td>
    </ng-container>
  </comp-paged-table>
</article>
